import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Route, Switch } from "react-router-dom";
import React from "react";
import SEO from "../../UI/SEO/SEO";
import { getPreBasePath, getPreBaseRoute } from "../../../../components";
import PipelineDetail from "./PipelineDetail";
import { PipelineList } from "./PipelineList";
export const getPipelinesBaseRoute = () => getPreBaseRoute() + "/app/pipeline";
export const getPipelinesBasePath = (virtualizedApp) => getPreBasePath(virtualizedApp) + "/app/pipeline";
export const getPipelinesListRoute = getPipelinesBaseRoute;
export const getPipelinesListPath = (virtualizedApp) => getPipelinesBasePath(virtualizedApp);
export const getPipelineDetailPath = (pipelineId, virtualizedApp) => getPipelinesBasePath(virtualizedApp) + `/${pipelineId}`;
export const getPipelineAdminListRoute = () => "/aviso/app/admin/pipelines/";
export const getPipelineCreateRoute = () => "/aviso/app/admin/pipelines/create";
export const getPipelineEditRoute = (pipelineId) => `/aviso/app/admin/pipelines/edit/${pipelineId}`;
export const getPipelineDetailRoute = () => getPipelinesBaseRoute() + "/:pipelineId";
const PipelineRoutes = () => (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Pipelines" }), _jsxs(Switch, { children: [_jsx(Route, { component: PipelineDetail, path: getPipelineDetailRoute() }), _jsx(Route, { component: PipelineList, path: getPipelinesListRoute() })] })] }));
export default PipelineRoutes;
